import Image from "next/image";
import { FC } from "react";

interface BFLImageProps {
  alt: string;
  src: string;
  width?: number;
  height?: number;
  priority?: boolean;
  loading?: "eager" | "lazy";
  unoptimized?: boolean;
  quality?: number;
  className?: string;
  fill?: boolean;
  sizes?: string;
  placeholder?: "blur" | "empty";
  blurDataURL?: string;
  decoding?: "async" | "auto";
  fetchPriority?: "high" | "low" | "auto";
}

const BFLImage: FC<BFLImageProps> = ({
  alt = "",
  src,
  width,
  height,
  loading = "lazy",
  unoptimized = false,
  quality = 100,
  priority = false,
  className,
  fill = false,
  sizes,
  placeholder,
  blurDataURL,
  decoding = "auto",
  fetchPriority,
}) => {
  if (!src) {
    return;
  }
  return (
    <Image
      src={src}
      alt={alt}
      quality={quality}
      loading={loading}
      decoding={decoding}
      {...(priority && { priority })}
      {...(fetchPriority && { fetchPriority })}
      {...(unoptimized && { unoptimized })}
      {...(width && { width })}
      {...(height && { height })}
      {...(fill && { fill })}
      {...(className && { className })}
      {...(sizes && { sizes })}
      {...(placeholder && { placeholder })}
      {...(blurDataURL && { blurDataURL })}
    />
  );
};

export default BFLImage;
